import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Button, Card, Col, Container, Label, Row, Spinner } from "reactstrap";
import { getMoreAthleteMomentos } from "../../store/actions/MomentosActions";
import moment from "moment/moment";
import { toast } from "react-toastify";
import {
    getAthleteMomentosDrafts,
    deleteDraftMomento,
} from "../../store/actions/DraftDataAction";

const MomentosDrafts = () => {
    const dispatch = useDispatch();
    const { uid, user } = useSelector((state) => state.authUser);
    const {
        draftData,
        draftLoading,
        hasMoreDraftDocuments,
        draftLastDocument,
    } = useSelector((state) => state.draftReducer);
    const history = useHistory();
    const [modal, setModal] = useState(false);
    const [allowDetailsIndex, setAllowDetailsIndex] = useState(-1);
    const [loadMore, setLoadMore] = useState(false);
    const [loader, setLoader] = useState({
        data: false,
        loadMore: false,
    });
    const toggle = () => setModal(!modal);
    const formatDate = (date) => {
        const unixTimestamp = date.seconds + date.nanoseconds / 1e9;
        const jsDate = new Date(unixTimestamp * 1000);

        const formattedDate = moment(jsDate).format("DD/MM/YYYY HH:mm");
        return formattedDate;
    };
    const deleteDraftsMomento = (id) => {
        dispatch(
            deleteDraftMomento(id, () => {
                toast.success("Memento Deleted Successfully");
            })
        );
    };
    const loadMoreDDraft = () => {
        setLoader((prev) => ({
            ...prev,
            loadMore: true,
        }));
        dispatch(
            getAthleteMomentosDrafts(draftLastDocument, user.athleteID, () => {
                setLoader((prev) => ({
                    ...prev,
                    loadMore: false,
                }));
            })
        );
    };
    useEffect(() => {
        setLoader((prev) => ({
            ...prev,
            data: true,
        }));
        dispatch(
            getAthleteMomentosDrafts("", user.athleteID, () => {
                setLoader((prev) => ({
                    ...prev,
                    data: false,
                }));
            })
        );
    }, []);
    console.log("draft", draftData);
    return (
        <Container fluid>
            <Row className="justify-content-center  mx-4 py-3">
                <h3>Manage Momentos Drafts</h3>
            </Row>
            {loader.data ? (
                <Row className="justify-content-center">
                    <Spinner size="sm" />
                </Row>
            ) : (
                <Container>
                    {draftData.length > 0 ? (
                        draftData?.map((item, index) => {
                            return (
                                <>
                                    <Card
                                        className="mb-5 p-4 create_momento-card"
                                        key={item.id}
                                    >
                                        <Row className="p-3 d-flex justify-content-center align-items-center">
                                            <Col lg={4} md={4} sm={10}>
                                                <div>
                                                    <Label>Memento Title</Label>
                                                    <p>
                                                        <strong>
                                                            {item?.momentoTitle}
                                                        </strong>
                                                    </p>
                                                </div>
                                                <div>
                                                    <Label>
                                                        Memento Description
                                                    </Label>
                                                    <p>
                                                        <strong>
                                                            {
                                                                item?.momentoDescription
                                                            }
                                                        </strong>
                                                    </p>
                                                </div>
                                            </Col>
                                            <Col lg={4} md={4} sm={10}>
                                                <div>
                                                    <Label>Athlete</Label>
                                                    <p>
                                                        <strong>
                                                            {item?.athleteName}
                                                        </strong>
                                                    </p>
                                                </div>
                                                <div>
                                                    <Label>Created</Label>
                                                    <p>
                                                        <strong>
                                                            {item?.createdAt &&
                                                                formatDate(
                                                                    item?.createdAt
                                                                )}
                                                        </strong>
                                                    </p>
                                                </div>
                                            </Col>
                                            <Col lg={4} md={4} sm={10}>
                                                <div>
                                                    <Label>Memento ID</Label>
                                                    <p>
                                                        <strong>
                                                            {" "}
                                                            {item?.momentoID}
                                                        </strong>
                                                    </p>
                                                </div>
                                                <div>
                                                    <Label>Athlete ID</Label>
                                                    <p>
                                                        <strong>
                                                            {item?.athleteID}
                                                        </strong>
                                                    </p>
                                                </div>
                                            </Col>
                                        </Row>
                                        {allowDetailsIndex === index && (
                                            <Container className="d-flex flex-column momento__media">
                                                <Row className="p-3 flex-nowrap">
                                                    <Col className="col-1 d-flex flex-column justify-content-around pt-5 mr-1 pl-0 momento__media-qrCode_col">
                                                        {item.qrCodes?.map(
                                                            (qrCode, qrIdx) => {
                                                                if (
                                                                    qrIdx ==
                                                                        0 ||
                                                                    qrIdx == 1
                                                                ) {
                                                                    return (
                                                                        <>
                                                                            {qrCode !==
                                                                            "" ? (
                                                                                <div className="position-relative">
                                                                                    <img
                                                                                        src={
                                                                                            qrCode instanceof
                                                                                            File
                                                                                                ? URL.createObjectURL(
                                                                                                      qrCode
                                                                                                  )
                                                                                                : qrCode
                                                                                        }
                                                                                        className="w-100 create_momento-QR_img"
                                                                                        alt={`QR Code ${qrIdx}`}
                                                                                    />
                                                                                </div>
                                                                            ) : (
                                                                                <div className="create_momento-qrcode_div d-flex justify-content-center align-items-center border-0"></div>
                                                                            )}
                                                                        </>
                                                                    );
                                                                }
                                                            }
                                                        )}
                                                    </Col>

                                                    {item?.momento?.map(
                                                        (momentoItem) => {
                                                            return (
                                                                <Col className="p-2 momento__media-card">
                                                                    <Card className="w-100 p-3 create_momento-card d-flex flex-column justify-content-start align-items-center">
                                                                        <p className="mt-3 text-capitalize">
                                                                            <strong>
                                                                                {
                                                                                    momentoItem.title
                                                                                }
                                                                            </strong>
                                                                        </p>
                                                                        <p className="mt-3 text-capitalize">
                                                                            {
                                                                                momentoItem.subTitle
                                                                            }
                                                                        </p>

                                                                        <div className="create_momento__media-div">
                                                                            {momentoItem?.media ? (
                                                                                <img
                                                                                    src={
                                                                                        momentoItem.media
                                                                                    }
                                                                                    alt="img"
                                                                                    className="w-100 create_momento__media-div_img"
                                                                                />
                                                                            ) : (
                                                                                <>
                                                                                    No
                                                                                    Media
                                                                                    Attached
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    </Card>
                                                                </Col>
                                                            );
                                                        }
                                                    )}
                                                    <Col className="col-1 d-flex flex-column-reverse justify-content-around pt-5 mr-1 pr-0 momento__media-qrCode_col">
                                                        {item.qrCodes?.map(
                                                            (qrCode, qrIdx) => {
                                                                if (
                                                                    qrIdx ===
                                                                        item
                                                                            .qrCodes
                                                                            .length -
                                                                            2 ||
                                                                    qrIdx ===
                                                                        item
                                                                            .qrCodes
                                                                            .length -
                                                                            1
                                                                ) {
                                                                    return (
                                                                        <>
                                                                            {qrCode !==
                                                                            "" ? (
                                                                                <div className="position-relative">
                                                                                    <img
                                                                                        src={
                                                                                            qrCode instanceof
                                                                                            File
                                                                                                ? URL.createObjectURL(
                                                                                                      qrCode
                                                                                                  )
                                                                                                : qrCode
                                                                                        }
                                                                                        className="w-100 create_momento-QR_img"
                                                                                        alt={`QR Code ${qrIdx}`}
                                                                                    />
                                                                                </div>
                                                                            ) : (
                                                                                <div className="create_momento-qrcode_div d-flex justify-content-center align-items-center border-0"></div>
                                                                            )}
                                                                        </>
                                                                    );
                                                                }
                                                            }
                                                        )}
                                                    </Col>
                                                </Row>
                                                <Row className="d-flex justify-content-between align-items-center mx-0 px-0 my-3 flex-nowrap">
                                                    {item.qrCodes?.map(
                                                        (qrCode, qrIdx) => {
                                                            if (
                                                                qrIdx >= 2 &&
                                                                qrIdx <
                                                                    item.qrCodes
                                                                        .length -
                                                                        2
                                                            ) {
                                                                return (
                                                                    <div className="momento__media-qrCode_row">
                                                                        {qrCode !==
                                                                        "" ? (
                                                                            <div className="position-relative">
                                                                                <img
                                                                                    src={
                                                                                        qrCode instanceof
                                                                                        File
                                                                                            ? URL.createObjectURL(
                                                                                                  qrCode
                                                                                              )
                                                                                            : qrCode
                                                                                    }
                                                                                    className="w-100 create_momento-QR_img"
                                                                                    alt={`QR Code ${qrIdx}`}
                                                                                />
                                                                            </div>
                                                                        ) : (
                                                                            <div className="create_momento-qrcode_div d-flex justify-content-center align-items-center border-0"></div>
                                                                        )}
                                                                    </div>
                                                                );
                                                            }
                                                        }
                                                    )}
                                                </Row>
                                            </Container>
                                        )}

                                        <Row className=" my-3 justify-content-center justify-content-md-end pr-md-4">
                                            <Button
                                                size="sm"
                                                color="info"
                                                className="mx-2"
                                                onClick={() =>
                                                    history.push(
                                                        `/main/editDraft-momento/${item?.id}`
                                                    )
                                                }
                                            >
                                                Edit Draft
                                            </Button>
                                            <Button
                                                size="sm"
                                                color="danger"
                                                className="mr-2"
                                                onClick={() => {
                                                    toggle();
                                                    deleteDraftsMomento(
                                                        item?.id
                                                    );
                                                    // setID(item?.id);
                                                }}
                                            >
                                                Delete Draft
                                            </Button>
                                        </Row>
                                    </Card>
                                </>
                            );
                        })
                    ) : (
                        <p className="text-center">Don't have any Draft</p>
                    )}
                    <Row className="float-right mt-2 mb-4 mr-3">
                        {draftData.length > 4 && (
                            <Button
                                color="primary"
                                size="sm"
                                disabled={!hasMoreDraftDocuments}
                                onClick={loadMoreDDraft}
                            >
                                Load more
                            </Button>
                        )}
                    </Row>
                </Container>
            )}
        </Container>
    );
};

export default MomentosDrafts;
